import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { AccountManagementRoutingModule } from '@module/account-management/account-management-routing.module';
import { AgreementCreditsModule } from '@module/agreement-credits/agreement-credits.module';
import { NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@shared/components/ng-select/ng-select.module';
import { SharedPipesModule } from '@shared/pipes/shared-pipes.module';
import { SharedFormlyModule } from 'app/shared-formly/shared-formly.module';
import { AccordionModule } from 'primeng/accordion';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        AccountManagementRoutingModule,
        TableModule,
        TranslateModule,
        SharedModule,
        NgSelectModule,
        ReactiveFormsModule,
        FormsModule,
        FormlyBootstrapModule,
        AccordionModule,
        FontAwesomeModule,
        NgbDropdownModule,
        DialogModule,
        FormlyModule.forChild(),
        SharedFormlyModule,
        LocalizeRouterModule,
        NgbAccordionModule,
        MatProgressSpinnerModule,
        AgreementCreditsModule,
        SharedPipesModule,
    ],
    providers: [
        MessageService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccountManagementModule {
}
